import { lazyWithPreload } from './utils'

export const AboutEtfs = lazyWithPreload(
  () => import('../../pages/invest/core/fund/AboutEtfs'),
)
export const AboutPortfolio = lazyWithPreload(
  () => import('../../pages/portfolio/AboutPortfolio'),
)
export const AboutSustainability = lazyWithPreload(
  () => import('../../pages/portfolio/AboutSustainability'),
)
export const AccountsDocumentUploader = lazyWithPreload(
  () => import('../../pages/settings/linked-accounts/document-uploader'),
)
export const ActionFeedDev = lazyWithPreload(
  () => import('../../pages/action-feed'),
)
export const Alerts = lazyWithPreload(
  () => import('../../pages/message-center'),
)
export const BenefitsHub = lazyWithPreload(
  () => import('../../pages/benefits-hub/BenefitsHub'),
)
export const ChangePassword = lazyWithPreload(
  () => import('../../pages/settings/change-password'),
)
export const ChangeFundingSourceFlow = lazyWithPreload(
  () => import('../../pages/settings/linked-accounts/changeFundingSource'),
)

export const CheckHistoryScreen = lazyWithPreload(
  () => import('../../pages/spend/screens/check-history'),
)
export const CombinedClosure = lazyWithPreload(
  () => import('../../pages/close-account-v3/combined-closure'),
)
export const CorePotential = lazyWithPreload(
  () => import('../../pages/invest/core/Potential'),
)
export const DirectDepositForm = lazyWithPreload(
  () => import('../../pages/spend/direct-deposit-form'),
)
export const DirectDepositOnline = lazyWithPreload(
  () => import('../../pages/spend/direct-deposit/online'),
)
export const DirectDepositPDF = lazyWithPreload(
  () => import('../../pages/spend/direct-deposit/pdf'),
)
export const DirectDepositPDFDownload = lazyWithPreload(
  () => import('../../pages/spend/direct-deposit/pdf/download'),
)
export const DirectDepositSearch = lazyWithPreload(
  () => import('../../pages/spend/direct-deposit/search'),
)
export const DirectDepositSubmittable = lazyWithPreload(
  () => import('../../pages/spend/direct-deposit/submittable'),
)
export const DirectDepositSuccess = lazyWithPreload(
  () => import('../../pages/spend/direct-deposit/success'),
)
export const DocumentUploader = lazyWithPreload(
  () => import('../../pages/document-uploader'),
)
export const DocumentUploaderResult = lazyWithPreload(
  () => import('../../pages/document-uploader-result'),
)
export const DowngradeFlow = lazyWithPreload(
  () => import('../../pages/settings/my-subscription/downgrade'),
)
export const Early = lazyWithPreload(() => import('../../pages/early'))
export const EarlyAgeOfTransferReached = lazyWithPreload(
  () => import('../../pages/early/age-of-transfer-reached'),
)
export const EarlyAgeOfTransferFAQ = lazyWithPreload(
  () => import('../../pages/early/age-of-transfer-faq'),
)
export const EarlyAgeOfTransferNextSteps = lazyWithPreload(
  () => import('../../pages/early/age-of-transfer-next-steps'),
)
export const EarlyCloseAccount = lazyWithPreload(
  () => import('../../pages/close-account-v3/early'),
)
export const EarlyGifts = lazyWithPreload(
  () => import('../../pages/early/gifts'),
)
export const EarlyInvestmentDisclosure = lazyWithPreload(
  () => import('../../pages/early/investment-disclosure'),
)
export const EarlyInvestments = lazyWithPreload(
  () => import('../../pages/early/investments'),
)
export const EarlyOneTime = lazyWithPreload(
  () => import('../../pages/early/one-time'),
)
export const EarlyOneTimeV2 = lazyWithPreload(
  () => import('../../pages/early/one-timeV2'),
)
export const EarlyPotential = lazyWithPreload(
  () => import('../../pages/early/potential'),
)
export const EarlyRecurring = lazyWithPreload(
  () => import('../../pages/early/recurring'),
)
export const EarlyRecurringPotential = lazyWithPreload(
  () => import('../../pages/early/recurring-potential'),
)
export const EarlySettings = lazyWithPreload(
  () => import('../../pages/early/account-settings'),
)
export const EarlyWithdraw = lazyWithPreload(
  () => import('../../pages/early/withdraw/Withdraw'),
)
export const EarlyWithdrawInterstitial = lazyWithPreload(
  () => import('../../pages/early/withdraw-interstitial/WithdrawInterstitial'),
)
export const EmergencyFund = lazyWithPreload(
  () => import('../../pages/emergency-fund'),
)
export const EmergencyFundDownloadAcorns = lazyWithPreload(
  () => import('../../pages/emergency-fund/download-acorns'),
)
export const EmergencyFundRecentActivity = lazyWithPreload(
  () => import('../../pages/emergency-fund/recent-activity'),
)
export const EmergencyFundLocked = lazyWithPreload(
  () => import('../../pages/emergency-fund/locked-account'),
)
export const EmergencyFundClosed = lazyWithPreload(
  () => import('../../pages/emergency-fund/closed'),
)
export const EmergencyFundSettings = lazyWithPreload(
  () => import('../../pages/emergency-fund/settings'),
)
export const EmergencyFundTransfer = lazyWithPreload(
  () => import('../../pages/emergency-fund/transfer'),
)
export const EmergencyFundTransferSuccess = lazyWithPreload(
  () => import('../../pages/emergency-fund/transfer/SuccessPage'),
)
export const EmergencyFundVerificationRequired = lazyWithPreload(
  () => import('../../pages/emergency-fund/verification'),
)
export const FindATMScreen = lazyWithPreload(
  () => import('../../pages/spend/screens/find-atm'),
)
export const Fund = lazyWithPreload(
  () => import('../../pages/invest/core/fund'),
)
export const GrowArticle = lazyWithPreload(
  () => import('../../pages/grow/GrowArticle'),
)
export const InvestHub = lazyWithPreload(() => import('../../pages/invest/hub'))
export const Institution = lazyWithPreload(
  () => import('../../pages/settings/linked-accounts/institution'),
)
export const InvestClosure = lazyWithPreload(
  () => import('../../pages/close-account-v3/invest'),
)
export const Investor = lazyWithPreload(
  () => import('../../pages/settings/investor'),
)
export const InvestorPortfolioFlow = lazyWithPreload(
  () => import('../../pages/settings/investor/InvestorFlow'),
)
export const Invite = lazyWithPreload(() => import('../../pages/invite'))
export const InviteShare = lazyWithPreload(
  () => import('../../pages/invite/share'),
)

export const ReferralStatus = lazyWithPreload(
  () => import('../../pages/referral-status'),
)

export const LaterBeneficiary = lazyWithPreload(
  () => import('../../pages/invest/later/beneficiary'),
)
export const LaterCloseAccount = lazyWithPreload(
  () => import('../../pages/close-account-v3/later'),
)
export const LaterDetails = lazyWithPreload(
  () => import('../../pages/invest/later/details'),
)
export const Later = lazyWithPreload(
  () => import('../../pages/invest/later/hub'),
)

export const LaterOneTimeV2 = lazyWithPreload(
  () => import('../../pages/invest/later/one-timeV2'),
)

export const LaterRecurring = lazyWithPreload(
  () => import('../../pages/invest/later/recurring'),
)

export const LaterWithdrawV2 = lazyWithPreload(
  () => import('../../pages/invest/later/withdrawV2'),
)

export const CompareTiers = lazyWithPreload(
  () => import('../../pages/settings/CompareTiers'),
)

export const LinkedAccounts = lazyWithPreload(
  () => import('../../pages/settings/linked-accounts'),
)
export const Logout = lazyWithPreload(() => import('../../pages/logout'))
export const MinorDetails = lazyWithPreload(
  () => import('../../pages/early/minor-account-details/MinorAccountDetails'),
)
export const MySubscription = lazyWithPreload(
  () => import('../../pages/settings/my-subscription'),
)
export const Notifications = lazyWithPreload(
  () => import('../../pages/settings/notifications'),
)
export const OfferDetails = lazyWithPreload(
  () => import('../../pages/offer-details'),
)
export const OneTime = lazyWithPreload(
  () => import('../../pages/invest/core/one-time'),
)
export const OneTimeSuccess = lazyWithPreload(
  () => import('../../pages/invest/core/withdraw/SuccessPage'),
)
export const PageNotFound = lazyWithPreload(() => import('../../pages/404'))
export const PastScreen = lazyWithPreload(
  () => import('../../pages/home/screens/past'),
)
export const Personal = lazyWithPreload(
  () => import('../../pages/settings/personal'),
)
export const TrustedContactFormPage = lazyWithPreload(
  () => import('../../pages/settings/trusted-contact/TrustedContactFormPage'),
)
export const Privacy = lazyWithPreload(
  () => import('../../pages/settings/privacy'),
)
export const PortfolioHome = lazyWithPreload(
  () => import('../../pages/portfolio'),
)
export const PublishingArticle = lazyWithPreload(() =>
  import('../../pages/publishing/Article/ArticlePage').then((module) => ({
    default: module.ArticlePage,
  })),
)
export const QuarterlyRecap = lazyWithPreload(
  () => import('../../pages/early/quarterly-recap'),
)
export const PremiumTierUpgrade = lazyWithPreload(
  () => import('../../pages/early/quarterly-recap/upgrade'),
)
export const QuarterlyRecapSetup = lazyWithPreload(
  () => import('../../pages/early/quarterly-recap/setup'),
)
export const QuarterlyRecapShareSettings = lazyWithPreload(
  () => import('../../pages/early/quarterly-recap/share-settings'),
)
export const Recurring = lazyWithPreload(
  () => import('../../pages/invest/core/recurring'),
)
export const RecurringSuccess = lazyWithPreload(
  () => import('../../pages/success/recurring'),
)
export const RedeemGiftcard = lazyWithPreload(
  () => import('../../pages/redeem'),
)
export const RequestCard = lazyWithPreload(
  () => import('../../pages/settings/spend/request-card'),
)
export const RoundUps = lazyWithPreload(
  () => import('../../pages/invest/core/roundUps'),
)
export const RoundupSettings = lazyWithPreload(
  () => import('../../pages/invest/core/roundUpSettings'),
)
export const SendCheckScreen = lazyWithPreload(
  () => import('../../pages/spend/screens/send-check'),
)
export const SettingsPage = lazyWithPreload(
  () => import('../../pages/settings/index'),
)
export const ShippingAddress = lazyWithPreload(
  () => import('../../pages/settings/spend/shipping-address'),
)
export const SmartDeposit = lazyWithPreload(
  () => import('../../pages/spend/smart-deposit'),
)

export const Spend = lazyWithPreload(() => import('../../pages/spend'))
export const SpendActivation = lazyWithPreload(
  () => import('../../pages/spend/screens/activation'),
)
export const SpendChangePin = lazyWithPreload(
  () => import('../../pages/settings/spend/pin'),
)
export const SpendCloseAccount = lazyWithPreload(
  () => import('../../pages/close-account-v3/spend'),
)
export const SpendLockedAccount = lazyWithPreload(
  () => import('../../pages/spend/locked-account'),
)
export const SpendRecurring = lazyWithPreload(
  () => import('../../pages/spend/recurring'),
)
export const SpendReissue = lazyWithPreload(
  () => import('../../pages/spend/reissue'),
)
export const SpendSettings = lazyWithPreload(
  () => import('../../pages/settings/spend'),
)
export const SpendSignupV2 = lazyWithPreload(
  () => import('../../pages/spend/screens/SignupV2'),
)
export const StandaloneSignaturePage = lazyWithPreload(
  () =>
    import('../../pages/spend/screens/SignupV2/signature/StandaloneSignaturePage'),
)
export const SSNUploadComplete = lazyWithPreload(
  () => import('../../pages/early/ssn-upload-complete'),
)
export const SSNUploadVerification = lazyWithPreload(
  () => import('../../pages/early/ssn-upload-verification'),
)
export const TransactionDetail = lazyWithPreload(
  () => import('../../pages/home/screens/past/TransactionDetails'),
)
export const Transfer = lazyWithPreload(
  () => import('../../pages/spend/transfer'),
)
export const ThemeFlow = lazyWithPreload(
  () => import('../../pages/portfolio/ChangePortfolioTheme/ThemeFlow'),
)
export const InvestTipsOnlyOnApp = lazyWithPreload(
  () => import('../../pages/invest/core/tips'),
)
export const EducationFlow = lazyWithPreload(
  () => import('../../pages/portfolio/EducationTour'),
)
export const UpgradeSuccess = lazyWithPreload(
  () =>
    import('../../pages/settings/my-subscription/tier-subscription-center/upgrade-success'),
)
export const WhatIsAnIra = lazyWithPreload(
  () => import('../../pages/invest/later/what-is-an-ira'),
)

export const Withdraw = lazyWithPreload(
  () => import('../../pages/invest/core/withdraw'),
)

export const LaterUpgradeLander = lazyWithPreload(
  () => import('../../pages/invest/later/upgradeLander'),
)

export const WithdrawSuccess = lazyWithPreload(
  () => import('../../pages/invest/core/withdraw/SuccessPage'),
)

export const InvestingHub = lazyWithPreload(
  () => import('../../pages/investing-hub/hub'),
)

export const Learn = lazyWithPreload(() => import('../../pages/learn'))

export const BankingHub = lazyWithPreload(
  () => import('../../pages/banking-hub/hub'),
)

export const MyReferrals = lazyWithPreload(
  () => import('../../pages/my-referrals'),
)

export const ReferralFriendsHistory = lazyWithPreload(
  () => import('../../pages/referral-friends-history'),
)

export const ReferralOffers = lazyWithPreload(
  () => import('../../pages/referral-offers'),
)

export const ReferralOffersRedirect = lazyWithPreload(
  () => import('../../pages/referral-offers-redirect'),
)

export const MoneyManager = lazyWithPreload(
  () => import('../../pages/money-manager'),
)
